import React, { useRef, useState, useMemo, useCallback } from "react";
import { Modal, Form, Row, Col, Input } from "antd";
import { connect } from "dva";
import { FlagNotesType } from "@/utils/enum";

const { TextArea } = Input;

const ChangeFlagModal = ({
  adminShipmentView,
  dispatch,
  visible,
  flagType,
  shipmentExpedited,
  problemRide,
  isDamaged,
  onClose,
  onCancel,
  refreshNotes,
}) => {
  const formRef = useRef();

  const [loading, setLoading] = useState(false);

  const { title, placeholder } = useMemo(() => {
    let changingFlagTitle = "";
    let newFlagState = "";

    if (flagType === FlagNotesType.AutosledExpedited) {
      changingFlagTitle = "Autosled Expedited";
      newFlagState = shipmentExpedited ? "on" : "off";
    } else if (flagType === FlagNotesType.ProblemRide) {
      changingFlagTitle = "Problem Ride";
      newFlagState = problemRide ? "on" : "off";
    } else if (flagType === FlagNotesType.IsDamaged) {
      changingFlagTitle = "Damaged";
      newFlagState = isDamaged ? "on" : "off";
    }

    const currentPlaceholder = `Reason for toggling ${changingFlagTitle} ${newFlagState}?`;

    return {
      title: changingFlagTitle,
      placeholder: currentPlaceholder,
    };
  }, [flagType, shipmentExpedited, problemRide, isDamaged]);

  const closeAndReset = useCallback(
    (reset = false) => {
      setLoading(false);
      formRef.current.resetFields();

      if (reset && typeof onCancel === "function") {
        // Reset parent state
        onCancel();
        return;
      }

      if (typeof onClose === "function") {
        onClose();
      }
    },
    [onClose, onCancel],
  );

  const handleFlagToggle = useCallback(() => {
    const adminShipmentData = adminShipmentView.data;

    formRef.current.validateFields().then(data => {
      let dispatchData = null;

      if (flagType === FlagNotesType.AutosledExpedited) {
        dispatchData = {
          type: "adminShipmentView/toggleExpedited",
          shipmentId: adminShipmentData.id,
          reason: data.note,
        };
      } else if (flagType === FlagNotesType.IsDamaged) {
        dispatchData = {
          type: "adminShipmentView/setShipmentAsDamaged",
          shipmentId: adminShipmentData.id,
          loadId: adminShipmentData.load.id,
          comments: data.note,
        };
      } else if (flagType === FlagNotesType.ProblemRide) {
        dispatchData = {
          type: "adminShipmentView/toggleProblemRide",
          shipmentId: adminShipmentData.id,
          reason: data.note,
        };
      }

      if (dispatchData === null) {
        return;
      }

      setLoading(true);

      dispatch(dispatchData).then(() => {
        closeAndReset(false);
        refreshNotes?.();
      });
    });
  }, [adminShipmentView, dispatch, flagType, closeAndReset, refreshNotes]);

  return (
    <Modal
      title={title}
      open={visible}
      onOk={handleFlagToggle}
      onCancel={() => closeAndReset(true)}
      confirmLoading={loading}
    >
      <Form ref={formRef}>
        <Row gutter={16}>
          <Col flex={1}>
            <Form.Item name="note" rules={[{ required: true, message: "Please enter reason" }]}>
              <TextArea rows={4} placeholder={placeholder} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default connect(({ adminShipmentView }) => ({
  adminShipmentView,
}))(ChangeFlagModal);
